import { z } from 'zod';

export const CustomTemplateApi = z.object({
  id: z.string(),
  name: z.string().describe('The template name'),
  version: z.int().describe('The latest version of the template'),
});
export type CustomTemplateApi = z.infer<typeof CustomTemplateApi>;

// Async-job handle returned by POST /v1/customTemplates/{templateId}/jobs, serialized
// as a `jobs` JSON:API resource so it lines up with the planned GET /v1/jobs/{jobId}.
export const CustomTemplateJobApi = z.object({
  id: z.string(),
  templateId: z.string().describe('Id of the template being generated'),
  status: z.literal('PENDING').describe('Initial job status'),
});
export type CustomTemplateJobApi = z.infer<typeof CustomTemplateJobApi>;
